import React from "react"
import { Box, Container } from "@mui/material"
import { Outlet } from "react-router-dom"
import { Topbar } from "./Topbar"
import { Footer } from "./Footer"

export const MainLayout: React.FC = () => {
	return (
		<Box
			sx={{
				width: "100%",
				maxWidth: "100vw",
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				overflowX: "hidden",
			}}
		>
			<Topbar />
			<Box
				component="main"
				sx={(theme) => ({
					flexGrow: 1,
					background: theme.palette.background.default,
					color: theme.palette.text.primary,
					width: "100%",
					maxWidth: "100vw",
					overflowX: "hidden",
					// фиксируем высоту AppBar
					paddingTop: "64px",
				})}
			>
				<Container
					maxWidth="lg"
					sx={{
						px: { xs: 2, sm: 3, md: 4 },
						py: { xs: 2, sm: 3, md: 4 },
					}}
				>
					<Outlet />
				</Container>
			</Box>
			<Footer />
		</Box>
	)
}

export default MainLayout
